// Return partner logo URL for LetStay based on utm_source.

const SOURCE_TO_LOGO_URL = {
    // examples
    // bookaflight: 'https://assets.letstay.co.il/login/buka/logo-booka.png',
    // alice: 'https://assets.letstay.co.il/login/alice/logo-alice.png',
};

function normalizeUtmSource(utmSource) {
    if (!utmSource || typeof utmSource !== 'string') return '';
    return utmSource.trim().toLowerCase();
}

function getLetstayPartnerLogoUrl(utmSource) {
    const key = normalizeUtmSource(utmSource);
    return SOURCE_TO_LOGO_URL[key] || null;
}

module.exports = {
    getLetstayPartnerLogoUrl,
};
